const PHONE_NUMBER_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const PHONE_NUMBER_LENGTH = 10;
const MASKED_PHONE_NUMBER_LENGTH = 14;
const ZIP_LENGTH = 5;

const SSN_REQUIRED = {
    YES: 'YES',
    NO: 'NO',
};

const CALL_PERMISSION = {
    YES: 'YES',
    NO: 'NO',
};

const ssnOptions = [
    { value: 'YES', text: 'member.label.ssn.required' },
    { value: 'NO', text: 'member.label.ssn.not_required' },
];

const ssnNotReqdReasons = [
    { value: '', text: 'ssnnotreqdreason.select_reason' },
    {
        value: 'RELIGIOUS_EXCEPTION',
        text: 'ssnnotreqdreason.religious_exception',
    },
    { value: 'JUST_APPLIED', text: 'ssnnotreqdreason.just_applied' },
    { value: 'ILLNESS_EXCEPTION', text: 'ssnnotreqdreason.illness_exception' },
    { value: 'CITIZEN_EXCEPTION', text: 'ssnnotreqdreason.citizen_exception' },
    { value: 'OTHER', text: 'ssnnotreqdreason.other' },
];

const INVALID_CONSUMER = 'INVALID_CONSUMER';
const INVALID_EMAIL = 'INVALID_EMAIL';

const MIN_AGE_LIMIT = 18;
const MAX_AGE_LIMIT = 120;

export {
    CALL_PERMISSION,
    INVALID_CONSUMER,
    INVALID_EMAIL,
    MAX_AGE_LIMIT,
    MIN_AGE_LIMIT,
    PHONE_NUMBER_LENGTH,
    MASKED_PHONE_NUMBER_LENGTH,
    PHONE_NUMBER_MASK,
    SSN_REQUIRED,
    ZIP_LENGTH,
    ssnNotReqdReasons,
    ssnOptions,
};
